import './DetailMobile.scss';
import { motion } from 'framer-motion';
import CloseIcon from '../../../../../assets/icons/close.svg';
import React from 'react';
import Carousel from '../Carousel/Carousel';
import Marks from '../Marks/Marks';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function CarModelMobile({ tab, swiperRef, onClickMark, onClose, setSlideIndex }) {
  // const isOpen = tab.marksJaecooJ7Phev.some((el) => el.open);
  const isOpen = tab.marks.some((el) => el.open);
  return (
    <div className={'car-model-details-mobile'}>
      <div className={'wrapper'} data-aos="fade-up">
        <div className={'top'}>
          <div className={'top_image'}>
            <Image field={tab?.mobileImage} alt={'img'} fill />
          </div>
          <Marks tab={tab} onClickMark={onClickMark} />
          <motion.button
            initial={{ visibility: 'hidden', opacity: 0 }}
            animate={{ visibility: isOpen ? 'visible' : 'hidden', opacity: isOpen ? 1 : 0 }}
            transition={{ duration: 0.7, ease: 'easeInOut' }}
            className={'top_close'}
            onClick={onClose}
          >
            <img src={CloseIcon} alt={'x'} />
          </motion.button>
        </div>
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{
            height: isOpen ? '345px' : '0',
            opacity: isOpen ? 1 : 0,
          }}
          transition={{ duration: 0.7, ease: 'easeInOut' }}
          style={{ overflow: 'hidden' }}
        >
          <Carousel marks={tab?.marks} swiperRef={swiperRef} setSlideIndex={setSlideIndex} />
        </motion.div>
      </div>
    </div>
  );
}
